/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var DocMinusIcon16Light = forwardRef('DocMinusIcon16Light', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { d: "M6 9a.5.5 0 0 0 0 1h4a.5.5 0 0 0 0-1H6Z" }),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M3 3.5A2.5 2.5 0 0 1 5.5 1h3.015a1.5 1.5 0 0 1 1.06.44l2.986 2.984A1.5 1.5 0 0 1 13 5.484V11.5a2.5 2.5 0 0 1-2.5 2.5h-5A2.5 2.5 0 0 1 3 11.5v-8ZM5.5 2A1.5 1.5 0 0 0 4 3.5v8A1.5 1.5 0 0 0 5.5 13h5a1.5 1.5 0 0 0 1.5-1.5V6H9.5A1.5 1.5 0 0 1 8 4.5V2H5.5Zm3.5.278L11.722 5H9.5a.5.5 0 0 1-.5-.5V2.278Z" })));
});
